<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" role="button" aria-label="Close"></i>
  </div>
</div>

<div class="modal-body">
  <div class="panel-body">

    <!-- Loading Spinner -->
    @if (loading) {
<div class="loading-section">
      <i class="fa fa-spinner fa-spin"></i>
      <span class="loading-text">Processing...</span>
    </div>
}

    <!-- Confirmation Content -->
    @if (!loading) {
<div>
      <div class="confirm-message">
        <span class="msg-title"><i class="Appkit4-icon icon-logout-fill"></i>Confirm</span>
        <br />
        Are you sure you want to delete the record?
      </div>

      <div class="a-modal-footer modal-footer pad-zero" style="float: right; display: flex; justify-content: flex-end; width: 100%">
        <ap-button [btnType]="'primary'" [label]="'Delete'" class="ap-mr-spacing-3"
          (onClick)="deleteData()">
        </ap-button>

        <ap-button [label]="'Cancel'" class="ap-mr-spacing-3" [btnType]="'primary'"
          (onClick)="cancel()">
        </ap-button>
      </div>
    </div>
}
  </div>
</div>